import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

// Gates a route to a specific logged-in role ("admin" | "client").
// "admin" also allows the "photographer" role (invited team members share
// the same studio dashboard). Redirects to /login if not authenticated.
export const ProtectedRoute = ({ role, children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-sm text-[hsl(var(--lxra-muted))]">
        Loading...
      </div>
    );
  }

  const allowedRoles = role === 'admin' ? ['admin', 'photographer'] : [role];
  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
